// Check for MobX observable objects without importing mobx.
// MobX tags every observable with a unique Symbol("mobx administration") property.
// Since it's a unique symbol (not Symbol.for), we detect it by matching the description.
// We do this so we don't have to import the entire mobx library
export function isObservable(value: any): boolean {
    if (value == null || typeof value !== 'object') {
        return false;
    }
    return Object.getOwnPropertySymbols(value).some(s => s.description === 'mobx administration');
}
